import createIcon from '../../createIcon';

/**
 * @component @name WbIncandescent
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy41NSAxOC41NjU0TDQuOTYgMTkuOTc1NEw2Ljc1IDE4LjE3NTRMNS4zNCAxNi43NjU0TDMuNTUgMTguNTY1NFpNMTEgMjIuNDc1NEgxM1YxOS41MjU0SDExVjIyLjQ3NTRaTTQgMTAuNTI1NEgxVjEyLjUyNTRINFYxMC41MjU0Wk0xNSA2LjMzNTM5VjEuNTI1MzlIOVY2LjMzNTM5QzcuMjEgNy4zNzUzOSA2IDkuMzA1MzkgNiAxMS41MjU0QzYgMTQuODM1NCA4LjY5IDE3LjUyNTQgMTIgMTcuNTI1NEMxNS4zMSAxNy41MjU0IDE4IDE0LjgzNTQgMTggMTEuNTI1NEMxOCA5LjMwNTM5IDE2Ljc5IDcuMzc1MzkgMTUgNi4zMzUzOVpNMjAgMTAuNTI1NFYxMi41MjU0SDIzVjEwLjUyNTRIMjBaTTE3LjI0IDE4LjE4NTRMMTkuMDMgMTkuOTg1NEwyMC40NCAxOC41NzU0TDE4LjY0IDE2Ljc4NTRMMTcuMjQgMTguMTg1NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WbIncandescent = createIcon('WbIncandescent', [
  [
    'path',
    {
      d: 'M3.55 18.5654L4.96 19.9754L6.75 18.1754L5.34 16.7654L3.55 18.5654ZM11 22.4754H13V19.5254H11V22.4754ZM4 10.5254H1V12.5254H4V10.5254ZM15 6.33539V1.52539H9V6.33539C7.21 7.37539 6 9.30539 6 11.5254C6 14.8354 8.69 17.5254 12 17.5254C15.31 17.5254 18 14.8354 18 11.5254C18 9.30539 16.79 7.37539 15 6.33539ZM20 10.5254V12.5254H23V10.5254H20ZM17.24 18.1854L19.03 19.9854L20.44 18.5754L18.64 16.7854L17.24 18.1854Z',
      key: '1243r3',
    },
  ],
]);

export default WbIncandescent;
